<template>
    <div v-if="recordSelected">
        <div class="modal fade" id="viewRecord" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Xem chi tiết bài học
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="stopVideo">
                            <span aria-hidden="true" class="text-danger"><i
                                    class="fa-regular fa-circle-xmark"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p><label for="exampleInputEmail1"><strong>Tên bài học</strong></label> : {{ recordSelected.lesson_name }}</p>
                        <p><label for="exampleInputEmail1"><strong>Vị trí bài học</strong></label> : {{ recordSelected.position }}</p>
                        <div class="mb-2">
                            <label for="exampleInputEmail1"><strong>Giới thiệu về bài học</strong></label>
                            <p class="container-html" v-html="recordSelected.lesson_introduce"></p>
                        </div>
                        <div class="cover-course mb-2">
                            <label for="exampleInputEmail1"><strong>Video bài học</strong></label>
                            <div class="video-lesson" :key="videoKey">
                                <vue3-video-player :src="recordSelected.lesson_video"
                                    ref="videoPlayer"></vue3-video-player>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" ref="closeButton"
                            @click="stopVideo">Đóng</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'; // Đảm bảo jQuery đã được import (yêu cầu cho Bootstrap)

export default {
    name: "ViewRecord",

    props: {
        recordSelected: Object
    },

    data() {
        return {
            videoKey: 0, // fix lỗi video không reload khi modal được bật lên
        };
    },

    mounted() {
        // Lắng nghe sự kiện modal bị ẩn
        const modal = document.getElementById('viewRecord');
        if (modal) {
            $(modal).on('hidden.bs.modal', this.stopVideo); // Sử dụng jQuery để gắn sự kiện
        }

        // Lắng nghe click vào backdrop
        $(document).on('click', '.modal-backdrop', this.stopVideoOnBackdropClick);
    },

    beforeUnmount() {
        // Xóa sự kiện khi component bị hủy
        const modal = document.getElementById('viewRecord');
        if (modal) {
            $(modal).off('hidden.bs.modal', this.stopVideo);
        }
        $(document).off('click', '.modal-backdrop', this.stopVideoOnBackdropClick);
    },

    methods: {
        stopVideo() {
            if (this.$refs.videoPlayer && this.$refs.videoPlayer.player) {
                this.$refs.videoPlayer.player.pause(); // Dừng video
                console.log('Video paused'); // Debug để kiểm tra
            } else {
                console.warn('Video player not found or not initialized');
            }
        },

        stopVideoOnBackdropClick() {
            // Đóng modal và dừng video khi click vào backdrop
            const modal = document.getElementById('viewRecord');
            if (modal && $(modal).hasClass('show')) {
                $(modal).modal('hide'); // Đóng modal
                this.stopVideo(); // Dừng video
            }
        }
    },

    watch: {
        recordSelected() {
            this.videoKey += 1; // Tăng videoKey để reload video khi recordSelected thay đổi
        }
    }
}
</script>

<style scoped src="@/components/modal-responsive.css"></style>
<style scoped>
.vue3-video-player {
    width: 100%;
    margin: 0 auto;
}

.modal-header .close {
    outline: none;
}

.modal-dialog {
    max-width: 800px;
}

.container-html {
    border: 1px solid silver;
    padding: 3px;
}
</style>